import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Dossier\DuplicateDossierController::__invoke
* @see app/Http/Controllers/Dossier/DuplicateDossierController.php
* @route '/api/dossier/{dossier}/duplicate'
*/
const DuplicateDossierController = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateDossierController.url(args, options),
    method: 'post',
})

DuplicateDossierController.definition = {
    methods: ["post"],
    url: '/api/dossier/{dossier}/duplicate',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Dossier\DuplicateDossierController::__invoke
* @see app/Http/Controllers/Dossier/DuplicateDossierController.php
* @route '/api/dossier/{dossier}/duplicate'
*/
DuplicateDossierController.url = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { dossier: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { dossier: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            dossier: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        dossier: typeof args.dossier === 'object'
        ? args.dossier.id
        : args.dossier,
    }

    return DuplicateDossierController.definition.url
            .replace('{dossier}', parsedArgs.dossier.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Dossier\DuplicateDossierController::__invoke
* @see app/Http/Controllers/Dossier/DuplicateDossierController.php
* @route '/api/dossier/{dossier}/duplicate'
*/
DuplicateDossierController.post = (args: { dossier: string | number | { id: string | number } } | [dossier: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: DuplicateDossierController.url(args, options),
    method: 'post',
})

export default DuplicateDossierController